/**
 * @author gll
 * 模块说明：采购定价
 */
import { Service } from '@/tools'

export class FixedPriceService<T extends TProcure.FixedPrice> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.FixedPrice}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：分页查询采购定价列表
   */
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiPage', data)
  }

  /**
   * 模块说明：删除采购定价
   */
  delete = <K extends T['ApiDelete']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiDelete', data)
  }

  /**
   * 模块说明：目录期号到期删除采购定价
   */
  deleteByCatalogeNum = <K extends T['ApiDeleteByCatalogeNum']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiDeleteByCatalogeNum', data)
  }

  /**
   * 模块说明：查询采购折扣
   */
  selectFixedPrice = <K extends T['ApiSelectFixedPrice']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiSelectFixedPrice', data)
  }

   /**
   * 模块说明：需求单-人工备货寻源查询供应商
   *  /api/procure/fixedPrice/v1/querySupplier
   */
   querySupplier = <K extends T['ApiQuerySupplier']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiQuerySupplier', data)
  }
}
